export const SSB_STEPS = ['Define', 'Analyze', 'Results', 'Review', 'Export'] as const;

export type StepDefinition = (typeof SSB_STEPS)[number];
